import { createContext, useContext } from 'react';
import type { AppLayoutContextValue, AppLayoutProviderProps } from './types';

const AppLayoutContext = createContext<AppLayoutContextValue | undefined>(
  undefined,
);

/**
 * AppLayoutProvider provides context about the app layout state
 * to components that need to adjust their positioning (like SideModal or Modal).
 */
export function AppLayoutProvider({
  children,
  mainContentRef,
}: AppLayoutProviderProps) {
  const value: AppLayoutContextValue = {
    mainContentRef,
  };

  return (
    <AppLayoutContext.Provider value={value}>
      {children}
    </AppLayoutContext.Provider>
  );
}

/**
 * Returns information about the app layout context.
 */
export function useAppLayoutContext(): AppLayoutContextValue {
  const context = useContext(AppLayoutContext);
  if (context === undefined) {
    // Return default values if used outside provider
    return {
      mainContentRef: undefined,
    };
  }
  return context;
}
